(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-launch-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-launch-list')) {
  customElements.define('sg-launch-list', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      if (this.classList.contains('sg-launch--editorial') && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          if (entry.target.animate) entry.target.animate([{opacity: 0, transform: 'translateY(10px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 450, easing: 'ease-out'});
          observer.unobserve(entry.target);
        }), {threshold: .1});
        this.querySelectorAll('.sg-launch__prices article, .sg-launch__journey').forEach(el => observer.observe(el));
      }
      const form = this.querySelector('.sg-launch__form');
      const result = this.querySelector('.sg-launch__success:not([hidden]), .sg-launch__error');
      if (result) result.focus();
      if (!form) return;
      const name = form.querySelector('[name="contact[first_name]"]');
      const email = form.querySelector('[name="contact[email]"]');
      if (!name || !email) return;
      const lastName = form.querySelector('[name="contact[last_name]"]');
      const phone = form.querySelector('[data-phone-input]');
      const code = form.querySelector('[data-phone-code]');
      const phoneValue = form.querySelector('[data-phone-value]');
      const phoneNote = form.querySelector('[data-phone-note]');
      const validatePhone = () => {
        const raw = phone.value.trim();
        let digits = raw.replace(/[\s().-]/g, '');
        if (digits.startsWith('00')) digits = '+' + digits.slice(2);
        if (digits && !digits.startsWith('+') && code.value !== 'other') digits = '+' + code.value + digits;
        const valid = !raw || /^\+[1-9]\d{6,14}$/.test(digits);
        phone.setCustomValidity(valid ? '' : this.dataset.phoneError);
        phoneValue.value = phoneNote.value = valid && raw ? digits : '';
        phoneValue.disabled = phoneNote.disabled = !raw || !valid;
      };
      phone.addEventListener('input', validatePhone);
      code.addEventListener('change', validatePhone);
      const validateLastName = () => lastName.setCustomValidity(lastName.value.trim() ? '' : this.dataset.nameError);
      lastName.addEventListener('input', validateLastName);
      lastName.addEventListener('blur', () => { lastName.value = lastName.value.trim(); validateLastName(); });
      const preview = form.hasAttribute('data-launch-preview');
      const success = this.querySelector('[data-preview-success]');
      const validateName = () => name.setCustomValidity(name.value.trim() ? '' : this.dataset.nameError);
      name.addEventListener('input', validateName);
      name.addEventListener('blur', () => { name.value = name.value.trim(); validateName(); });
      email.addEventListener('blur', () => { email.value = email.value.trim(); });
      form.addEventListener('submit', event => {
        name.value = name.value.trim();
        email.value = email.value.trim();
        validateName();
        lastName.value = lastName.value.trim();
        validateLastName();
        validatePhone();
        if (!form.reportValidity()) {
          event.preventDefault();
          return;
        }
        if (preview) {
          event.preventDefault();
          form.hidden = true;
          success.hidden = false;
          success.focus();
        }
      });
      const reset = this.querySelector('[data-preview-reset]');
      if (preview && reset) reset.addEventListener('click', () => {
        form.reset();
        name.setCustomValidity('');
        lastName.setCustomValidity('');
        validatePhone();
        success.hidden = true;
        form.hidden = false;
        name.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-premium"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (!document.querySelector('#hero')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var header = document.querySelector('.site-header');
  var hero = document.querySelector('#hero');
  var subscription = document.querySelector('#subscription');
  var monthlyLink = document.querySelector('#subscription .plan:nth-child(2) a');
  var scroller = document.querySelector('.page-wrapper') || document.scrollingElement;
  var progress = document.createElement('div');
  var mobileCta = document.createElement('a');
  var scheduled = false;

  progress.className = 'sg-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);

  mobileCta.className = 'sg-mobile-subscribe';
  mobileCta.href = '#subscription';
  if (monthlyLink) {
    mobileCta.textContent = monthlyLink.textContent.trim();
    document.body.appendChild(mobileCta);
  }

  var subscriptionShortcut = document.querySelector('#editions a[href="#"]');
  if (subscriptionShortcut) subscriptionShortcut.href = '#subscription';

  var revealSelector = [
    'main section:not(#hero) .eyebrow',
    'main section:not(#hero) h2',
    'main section:not(#hero) article',
    'main section:not(#hero) .lead',
    'main section:not(#hero) .plans',
    'main section:not(#hero) .faq-list'
  ].join(',');

  var revealItems = Array.prototype.slice.call(document.querySelectorAll(revealSelector));
  revealItems.forEach(function (item) {
    var section = item.closest('section');
    var siblings = section ? Array.prototype.slice.call(section.querySelectorAll(revealSelector)) : [];
    var index = Math.max(0, siblings.indexOf(item));
    item.classList.add('sg-reveal');
    item.style.setProperty('--sg-reveal-delay', Math.min(index * 42, 210) + 'ms');
  });

  document.documentElement.classList.add('sg-premium-ready');

  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sg-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    revealItems.forEach(function (item) { revealObserver.observe(item); });
  } else {
    revealItems.forEach(function (item) { item.classList.add('sg-is-visible'); });
  }

  var navLinks = Array.prototype.slice.call(document.querySelectorAll('.site-header [data-sg-anchor]'));
  var navSections = navLinks.map(function (link) {
    return document.querySelector('[data-sg-anchor-target="' + link.getAttribute('data-sg-anchor') + '"]');
  }).filter(Boolean);

  if ('IntersectionObserver' in window) {
    var navObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.getAttribute('data-sg-anchor-target');
        navLinks.forEach(function (link) {
          var active = link.getAttribute('data-sg-anchor') === id;
          link.classList.toggle('sg-is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-34% 0px -55% 0px', threshold: 0 });
    navSections.forEach(function (section) { navObserver.observe(section); });
  }

  var steps = Array.prototype.slice.call(document.querySelectorAll('#protocol .step'));
  if ('IntersectionObserver' in window && steps.length) {
    var stepObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        steps.forEach(function (step) { step.classList.remove('sg-step-active'); });
        entry.target.classList.add('sg-step-active');
      });
    }, { rootMargin: '-32% 0px -48% 0px', threshold: 0 });
    steps.forEach(function (step) { stepObserver.observe(step); });
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceMotion.matches) {
    document.querySelectorAll('#editions .shotwrap').forEach(function (stage) {
      stage.addEventListener('pointermove', function (event) {
        var rect = stage.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - .5;
        var y = (event.clientY - rect.top) / rect.height - .5;
        stage.style.setProperty('--sg-tilt-x', (-y * 4).toFixed(2) + 'deg');
        stage.style.setProperty('--sg-tilt-y', (x * 5).toFixed(2) + 'deg');
      });
      stage.addEventListener('pointerleave', function () {
        stage.style.setProperty('--sg-tilt-x', '0deg');
        stage.style.setProperty('--sg-tilt-y', '0deg');
      });
    });
  }

  function updateFrame() {
    scheduled = false;
    var top = scroller === document.documentElement || scroller === document.body ? window.scrollY : scroller.scrollTop;
    var max = Math.max(1, scroller.scrollHeight - scroller.clientHeight);
    progress.style.setProperty('--sg-scroll-progress', Math.min(1, top / max));
    if (header) header.classList.toggle('sg-is-compact', top > 48);

    if (hero && !reduceMotion.matches) {
      var shift = Math.min(28, Math.max(-10, top * .035));
      hero.style.setProperty('--sg-hero-shift', shift.toFixed(1) + 'px');
    }

    var showCta = top > Math.min(520, window.innerHeight * .7);
    if (subscription) {
      var rect = subscription.getBoundingClientRect();
      if (rect.top < window.innerHeight * .8 && rect.bottom > window.innerHeight * .2) showCta = false;
    }
    mobileCta.classList.toggle('sg-is-visible', showCta);
  }

  function scheduleFrame() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateFrame);
  }

  scroller.addEventListener('scroll', scheduleFrame, { passive: true });
  window.addEventListener('resize', scheduleFrame, { passive: true });
  updateFrame();
})();
  } catch(e) { console.error(e); }
})();

})();
